module.exports = __webpack_public_path__ + "static/media/61.d3b3fa50.jpg";